import { Component, Input } from '@angular/core';
import { coEventsParameters, EventsProvider } from '../../providers/events/events';
import { AppState } from '../../config/state';
import { ConfigProvider } from '../../providers/config/config';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
import { NavController, ModalController, PopoverController } from 'ionic-angular';
import { CoLocationComponent } from '../co-location/co-location';
import { SocialMediaSharingProvider } from '../../providers/social-media-sharing/social-media-sharing';
/**
 * Generated class for the CoAttendEventCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-attend-event-card',
  templateUrl: 'co-attend-event-card.html'
})
export class CoAttendEventCardComponent {
  @Input() event: coEventsParameters;
  @Input() density: any;
  @Input('hideRegistrationButtons') hideRegistrationButtons: boolean = false;;
  agesArray: any;
  viewType: any;
  imageSrc: string = null;
  private iconsForPage: any;
  isSharedScreen: boolean;
  eventTypes: any;
  constructor(private state: AppState, private config: ConfigProvider, private navCtrl: NavController, public modalCtrl: ModalController, public popoverCtrl: PopoverController, private socialShare: SocialMediaSharingProvider, private eventsProvider: EventsProvider) {
    this.viewType = this.state.mode;
    this.isSharedScreen = this.state.sharedScreen;
    this.eventTypes = this.state.eventColors.types;
  }
  ngOnInit() {
    this.createIconThings();
    // console.log(this.event);
    if (this.event.eventImage) {
      this.imageSrc = `https://${this.state.client.keyword}.libnet.info/images/events/${this.state.client.keyword}/${this.event.eventImage}`
    } else {
      const eventType = this.event.types && this.event.types.length ? this.event.types[0] : null;
      this.imageSrc = `https://${this.state.client.keyword}.libnet.info/images/events/${this.state.client.keyword}/` + this.getEventImage(eventType);
    }
    // this.eventFullCheck(this.event);
  }
  goToEventDetails(event) {
    if (event.description && event.description.length > 0){
      this.config.load(this.state.appId).then(cfg => {
        this.navCtrl.push(CoEventDetailsComponent, { eventId: event.eventId });
      });
    } else {
      console.log('no description on clicked event: ', event)
    }
  }

  goToNewEvent(event) {
    if(event.newEventId) {
      this.config.load(this.state.appId).then(cfg => {
        this.navCtrl.push(CoEventDetailsComponent, { eventId: event.newEventId });
      })
    }
  }
  
  goToLocation(locationId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoLocationComponent, { location: locationId, showNavbar: true });
    });
  }
  getEventImage(eventType) {
    try {
      let eventTypeObject = this.eventTypes.find(object => object.name === eventType);
      return eventTypeObject.image;
    } catch (ex) {
      return "";
    }
  }

  openInterestedPopover(event) {
    // if (this.isSharedScreen){
    //   //set up the shared thingy
    // } else {
    //   let customClass = 'custom-popover-interested-button';
    //   let popover = this.popoverCtrl.create(CoInterestedPopoverComponent, {event: this.event, previousCard: this}, { cssClass: customClass });
    //   popover.present({
    //     ev: event
    //   });
    // }
    let self = this;
    this.eventsProvider.openInterestedPopover(event, this.event, self);
  }

  shareEvent(button) {
    if (this.viewType === 'app') {
      this.socialShare.shareOptions(this.event);
    } else if (this.viewType === 'desktop') {
      this.eventsProvider.openSocialMediaPopover(button, this.event);
    }
  }

  createIconThings() {
    let array = [
      ".am-2d-graphic-format:before { content: '\e800'; } /* '' */",
      ".am-3d-object-format:before { content: '\e801'; } /* '' */",
      ".am-activity:before { content: '\e802'; } /* '' */",
      ".am-add-new:before { content: '\e803'; } /* '' */",
      ".am-app-builder:before { content: '\e804'; } /* '' */",
      ".am-archive-format:before { content: '\e805'; } /* '' */",
      ".am-back-to-list:before { content: '\e806'; } /* '' */",
      ".am-book-format:before { content: '\e807'; } /* '' */",
      ".am-book:before { content: '\e808'; } /* '' */",
      ".am-braille-format:before { content: '\e809'; } /* '' */",
      ".am-cancel:before { content: '\e80a'; } /* '' */",
      ".am-channels:before { content: '\e80b'; } /* '' */",
      ".am-cloud:before { content: '\e80c'; } /* '' */",
      ".am-container:before { content: '\e80d'; } /* '' */",
      ".am-content:before { content: '\e80e'; } /* '' */",
      ".am-dashboard:before { content: '\e80f'; } /* '' */",
      ".am-delete:before { content: '\e810'; } /* '' */",
      ".am-directions:before { content: '\e811'; } /* '' */",
      ".am-displays:before { content: '\e812'; } /* '' */",
      ".am-dvd-format:before { content: '\e813'; } /* '' */",
      ".am-ebook-format:before { content: '\e814'; } /* '' */",
      ".am-edit-block:before { content: '\e815'; } /* '' */",
      ".am-edit:before { content: '\e816'; } /* '' */",
      ".am-events-blank:before { content: '\e817'; } /* '' */",
      ".am-events:before { content: '\e818'; } /* '' */",
      ".am-export:before { content: '\e819'; } /* '' */",
      ".am-fees-dollars:before { content: '\e81a'; } /* '' */",
      ".am-footers:before { content: '\e81b'; } /* '' */",
      ".am-form-builder:before { content: '\e81c'; } /* '' */",
      ".am-framework:before { content: '\e81d'; } /* '' */",
      ".am-globe-format:before { content: '\e81e'; } /* '' */",
      ".am-handle:before { content: '\e81f'; } /* '' */",
      ".am-headers:before { content: '\e820'; } /* '' */",
      ".am-help:before { content: '\e821'; } /* '' */",
      ".am-hide:before { content: '\e822'; } /* '' */",
      ".am-history-items:before { content: '\e823'; } /* '' */",
      ".am-hold-items:before { content: '\e824'; } /* '' */",
      ".am-hub:before { content: '\e825'; } /* '' */",
      ".am-image:before { content: '\e826'; } /* '' */",
      ".am-insert-block:before { content: '\e827'; } /* '' */",
      ".am-kit-format:before { content: '\e828'; } /* '' */",
      ".am-large-print-format:before { content: '\e829'; } /* '' */",
      ".am-layer:before { content: '\e82a'; } /* '' */",
      ".am-library-card:before { content: '\e82b'; } /* '' */",
      ".am-loan-items:before { content: '\e82c'; } /* '' */",
      ".am-locations-alt:before { content: '\e82d'; } /* '' */",
      ".am-locations:before { content: '\e82e'; } /* '' */",
      ".am-logout:before { content: '\e82f'; } /* '' */",
      ".am-map-format:before { content: '\e830'; } /* '' */",
      ".am-map:before { content: '\e831'; } /* '' */",
      ".am-messages:before { content: '\e832'; } /* '' */",
      ".am-microform-format:before { content: '\e833'; } /* '' */",
      ".am-motion-picture-format:before { content: '\e834'; } /* '' */",
      ".am-music-cd-format:before { content: '\e835'; } /* '' */",
      ".am-music-printed-format:before { content: '\e836'; } /* '' */",
      ".am-music-sound-rec-format:before { content: '\e837'; } /* '' */",
      ".am-my-items:before { content: '\e838'; } /* '' */",
      ".am-newspaper-format:before { content: '\e839'; } /* '' */",
      ".am-notifications:before { content: '\e83a'; } /* '' */",
      ".am-o-resources:before { content: '\e83b'; } /* '' */",
      ".am-ok:before { content: '\e83c'; } /* '' */",
      ".am-opening-hours:before { content: '\e83d'; } /* '' */",
      ".am-pages:before { content: '\e83e'; } /* '' */",
      ".am-picker:before { content: '\e83f'; } /* '' */",
      ".am-portals:before { content: '\e840'; } /* '' */",
      ".am-posts:before { content: '\e841'; } /* '' */",
      ".am-profile:before { content: '\e842'; } /* '' */",
      ".am-programme:before { content: '\e843'; } /* '' */",
      ".am-projected-format:before { content: '\e844'; } /* '' */",
      ".am-read-message:before { content: '\e845'; } /* '' */",
      ".am-save-as:before { content: '\e846'; } /* '' */",
      ".am-save:before { content: '\e847'; } /* '' */",
      ".am-scan-barcode:before { content: '\e848'; } /* '' */",
      ".am-scene:before { content: '\e849'; } /* '' */",
      ".am-search-alt:before { content: '\e84a'; } /* '' */",
      ".am-search:before { content: '\e84b'; } /* '' */",
      ".am-serial-format:before { content: '\e84c'; } /* '' */",
      ".am-settings:before { content: '\e84d'; } /* '' */",
      ".am-shape:before { content: '\e84e'; } /* '' */",
      ".am-show:before { content: '\e84f'; } /* '' */",
      ".am-sidebars:before { content: '\e850'; } /* '' */",
      ".am-signage-builder:before { content: '\e851'; } /* '' */",
      ".am-social-media:before { content: '\e852'; } /* '' */",
      ".am-sound-rec-format:before { content: '\e853'; } /* '' */",
      ".am-statistics:before { content: '\e854'; } /* '' */",
      ".am-text:before { content: '\e855'; } /* '' */",
      ".am-themes:before { content: '\e856'; } /* '' */",
      ".am-toolbox:before { content: '\e857'; } /* '' */",
      ".am-updates:before { content: '\e858'; } /* '' */",
      ".am-url-alias:before { content: '\e859'; } /* '' */",
      ".am-users:before { content: '\e85a'; } /* '' */",
      ".am-video-format:before { content: '\e85b'; } /* '' */",
      ".am-videogame-format:before { content: '\e85c'; } /* '' */",
      ".am-widgets:before { content: '\e85d'; } /* '' */",
      ".am-faqs:before { content: '\e85e'; } /* '' */",
      ".am-content-block:before { content: '\e85f'; } /* '' */",
      ".am-convert:before { content: '\e860'; } /* '' */",
      ".am-tile:before { content: '\e861'; } /* '' */",
      ".am-lock:before { content: '\e862'; } /* '' */",
      ".am-unlock:before { content: '\e863'; } /* '' */",
      ".am-share:before { content: '\e864'; } /* '' */",
      ".am-audiobook-format:before { content: '\e865'; } /* '' */",
      ".am-branches:before { content: '\e866'; } /* '' */",
      ".am-reserve:before { content: '\e867'; } /* '' */",
      ".am-reserve-alt:before { content: '\e868'; } /* '' */",
      ".am-download:before { content: '\e869'; } /* '' */",
      ".am-freeze:before { content: '\e86a'; } /* '' */",
      ".am-status:before { content: '\e86b'; } /* '' */",
      ".am-unfreeze:before { content: '\e86c'; } /* '' */",
      ".am-waitlist:before { content: '\e86d'; } /* '' */",
      ".am-attend-check-in-light:before { content: '\e86e'; } /* '' */",
      ".am-attend-light:before { content: '\e86f'; } /* '' */",
      ".am-check-in-light:before { content: '\e870'; } /* '' */",
      ".am-check-out-light:before { content: '\e871'; } /* '' */",
      ".am-discover-light:before { content: '\e872'; } /* '' */",
      ".am-ticket:before { content: '\e873'; } /* '' */",
      ".am-locations-light:before { content: '\e874'; } /* '' */",
      ".am-patron-light:before { content: '\e875'; } /* '' */",
      ".am-recommended-light:before { content: '\e876'; } /* '' */",
      ".am-renew-light:before { content: '\e877'; } /* '' */",
      ".am-reserve-light:before { content: '\e878'; } /* '' */",
      ".am-print:before { content: '\e879'; } /* '' */",
      ".am-home-light:before { content: '\e87a'; } /* '' */",
      ".am-scan-light:before { content: '\e87b'; } /* '' */",
      ".am-event-type:before { content: '\e87c'; } /* '' */",
      ".am-age-group:before { content: '\e87d'; } /* '' */",
      ".am-location-marker:before { content: '\e87e'; } /* '' */",
      ".am-keyword:before { content: '\e886'; } /* '' */",
      ".am-pdf-outline:before { content: '\e888'; } /* '' */",
      ".am-time-range:before { content: '\e889'; } /* '' */",
      ".am-density01:before { content: '\e88a'; } /* '' */",
      ".am-density02:before { content: '\e88b'; } /* '' */",
      ".am-density03:before { content: '\e88c'; } /* '' */"
    ]
    let output = [];
    array.forEach((thing) => {
      let a = thing.split(':')
      output.push(a[0].substr(1))
    });

    this.iconsForPage = output;
  }
}



// WEBPACK FOOTER //
// ./src/components/co-attend-event-card/co-attend-event-card.ts